const ACTIVE_CLASS = 'usage-seg-active';

export const initOffersUsageSwitch = (): void => {
    const interne = document.querySelector<HTMLElement>('[data-usage="interne"]');
    const commercial = document.querySelector<HTMLElement>('[data-usage="commercial"]');
    const menuId = commercial?.getAttribute('data-dropdown-toggle');
    const menu = menuId ? document.getElementById(menuId) : null;
    if (!interne || !commercial || !menu) return;

    // Le dropdown est ouvert tant que Flowbite n'a pas remis la classe `hidden`.
    const syncActive = (): void => {
        const open = !menu.classList.contains('hidden');
        commercial.classList.toggle(ACTIVE_CLASS, open);
        interne.classList.toggle(ACTIVE_CLASS, !open);
    };

    new MutationObserver(syncActive).observe(menu, {
        attributes: true,
        attributeFilter: ['class'],
    });
};
